import { z } from "zod";

export const commentQuerySchema = z
	.object({
		cursor: z.string().optional(),
		limit: z.coerce.number().int().min(1).max(50).default(20),
	})
	.strict();

export type CommentQueryPayload = z.infer<typeof commentQuerySchema>;
